import { render } from "./SpeakerButton.vue?vue&type=template&id=52caea19&scoped=true&ts=true&lang=pug"
import script from "./SpeakerButton.vue?vue&type=script&lang=ts"
export * from "./SpeakerButton.vue?vue&type=script&lang=ts"

import "./SpeakerButton.vue?vue&type=style&index=0&id=52caea19&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52caea19"]])

export default __exports__